var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.33333V4.66667C10.6667 3.19467 9.472 2 8 2C6.528 2 5.33333 3.19467 5.33333 4.66667V7.33333M11.3333 14H4.66667C4.29867 14 4 13.7013 4 13.3333V8C4 7.632 4.29867 7.33333 4.66667 7.33333H11.3333C11.7013 7.33333 12 7.632 12 8V13.3333C12 13.7013 11.7013 14 11.3333 14Z",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c196fc36bc85352afdd164fc09ae5fec.svg";
export { ForwardRef as ReactComponent };